// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1GUEo","footer":"ReportModalFilter_footer__2-JKH"};